
















import Vue from "vue";

export default Vue.extend( {
  name  : 'SoldOutAlert',
  props : {
    alert : {
      type     : Object,
      required : true
    }
  }
} );
